import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  makeStyles,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import {DialogProps} from 'packages/common-types/base-types';
import {UserInscriptions} from 'packages/common-types/schema-types';

type InscriptionListProps = DialogProps & {
  inscriptions: UserInscriptions[];
};

// Create a class that generate a random color
// for each user in the list.

// Create a function that generate a random color
// for each user in the list.

const useStyles = makeStyles((theme) => ({
  avatar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
}));

const InscriptionList = (props: InscriptionListProps) => {
  const {toggle, modalOpen, inscriptions} = props;
  const classes = useStyles();
  return (
    <Dialog
      open={modalOpen}
      scroll="paper"
      onClose={toggle}
      aria-labelledby="dialog-select-tournament"
    >
      <DialogTitle id="">Usuarios pre-inscritos al torneo</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {inscriptions?.length === 0
            ? `No hay usuarios pre-inscritos al torneo`
            : `Lista de usuarios que se han pre-inscrito al torneo`}
        </DialogContentText>
        <List>
          {inscriptions?.map((inscription) => {
            const {user, state} = inscription;
            return (
              <>
                <ListItem key={user?.uid}>
                  <ListItemAvatar>
                    <Avatar className={classes.avatar}>
                      {user?.fullName?.charAt(0)}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={user?.fullName} secondary={state} />
                </ListItem>{' '}
              </>
            );
          })}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={toggle} color="default">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InscriptionList;
